// extracted by mini-css-extract-plugin
export default {"card":"chat_card__SmE1B","chatSidebar":"chat_chatSidebar__kDKd3","search":"chat_search__l36-i"};